

export const PublicInterceptor = async(URL, method, body = undefined, Token = undefined) => {
    let respuesta = null;
    const tokenUser = localStorage.getItem(process.env.REACT_APP_StorageToken);
    const promesa = await fetch(`${process.env.REACT_APP_API_URL}/${URL}?${Date.now()}`, { 
        method: method,
        headers: {
            "Content-Type": "application/json",
            'x-access-token': Token
        },
        body: body && method !== 'GET' ? JSON.stringify(body) : undefined
    })

    await promesa.json()
    .then(function (res) {
        // console.log(res.data)
            respuesta =  res.data;
        })
        .catch((error) => {
            respuesta =  {error: error};
            console.error(respuesta);
        })
        return respuesta;
}